<form [formGroup] = "courseForm">
<div class="quiz-container">
  <div class="left-pane">
    <div class="course-input-section">
		<label class="input-label">Select Course</label>
      <select formControlName="selectedCourse">
        <option value="" disabled selected>Choose from your course</option>
        <option *ngFor="let course of _courseData; trackBy: trackByCourse" [value]="course.course_title">
	{{ course.course_title }}</option>
</select>

	  <div *ngIf="selectedCourseUnits.length" class="unit-checkbox-group">
  <label class="input-label">Units*</label>
  <div *ngFor="let unit of selectedCourseUnits; let i = index" class="unit-card">
	<div class="unit-header">
    <input type="checkbox" [value]="unit.unit_title" (change)="onUnitCheckboxChange($event)"
	 [checked]="selectedUnits.includes(unit.unit_title)" id="unit-{{ i }}"/>
    <label [for]="'unit-' + i">{{ unit.unit_title }}</label>
 </div>
   <div *ngIf="selectedUnits.includes(unit.unit_title)" class="topic-section">
	  <label class="topic-title">Topics*</label>
	  <div class="topic-list">
      <div *ngFor="let topic of unit.topics; let j = index" class="topic-item">
        <input type="checkbox"
               [value]="topic.topic_title"
                (change)="onTopicCheckboxChange($event, unit.unit_title)"
               [checked]="selectedTopic.includes(topic.topic_title)"
               id="topic-{{ i }}-{{ j }}"/>
        <label [for]="'topic-' + i + '-' + j">{{ topic.topic_title }}</label>
      </div>
</div>
</div>
</div>
</div>

      <label class="input-label">Custom Prompt (Optional)</label>
      <textarea placeholder="Add any specific topics or focus areas..." formControlName="customPrompt"></textarea>
    </div>

    <app-question-type [(selected)]="selectedType"></app-question-type>
    <app-difficulty [(selected)]="difficulty"></app-difficulty>

    <div class="question-input-section">
      <label for="questionCount" >Number of Questions</label>

      <div class="input-button-row">
        <input id="questionCount" type="number" min="0" max="5"
		 formControlName="quizCount"/>
      </div>
	  <small *ngIf="courseForm.get('quizCount')?.invalid && courseForm.get('quizCount')?.touched" 
	  class="text-danger smaller-text">Please enter a number between 1 and 5.</small>

      <div class="continue-btn-wrapper">
		<ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
        <button class="continue-btn" (click)="generateCourseWithAI()">
			<div class="btn-content">Continue</div>
        </button>
		</ng-container>
      </div>
    </div>
  </div>

  <div class="right-pane">
    <app-question-preview  [isPreviewVisible]="showPreview"></app-question-preview>
  </div>
</div>
</form>